export default __webpack_public_path__ + "static/media/win_four.70803e21.svg";